import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import './momentLocales';
import { patchMomentFrChOrdinal } from './patchMomentFrChOrdinal';
import en from './en.yml';
import fr from './fr.yml';
import de from './de.yml';
import it from './it.yml';

patchMomentFrChOrdinal();

const SUPPORTED_LANGS = ['fr', 'en', 'de', 'it'];

function normalizeSupportedLang(lng) {
    const code = String(lng || 'fr').toLowerCase().split(/[-_]/)[0];
    return SUPPORTED_LANGS.includes(code) ? code : 'fr';
}

function applyMomentLocale(lng) {
    const code = normalizeSupportedLang(lng);
    if (code === 'fr') {
        moment.locale('fr-ch');
        return;
    }
    if (code === 'de') {
        moment.locale('de-ch');
        return;
    }
    if (code === 'it') {
        moment.locale('it');
        return;
    }
    moment.locale('en');
}

function persistNormalizedLanguage(lng) {
    const normalizedLng = normalizeSupportedLang(lng);
    try {
        window.localStorage.setItem('i18nextLng', normalizedLng);
    } catch (error) {
        // Ignore storage write failures (private mode, disabled storage, etc.)
    }
}

const dotify = (obj) => {
    var res = {};
    function recurse(obj, current) {
        for (var key in obj) {
            var value = obj[key];
            var newKey = (current ? current + '.' + key : key);  // joined key with dot
            if (value && typeof value === 'object') {
                recurse(value, newKey);  // it's a nested object, so do it again
            } else {
                res[newKey] = value;  // it's not an object, so set the property
            }
        }
    }

    recurse(obj);
    return res;
};

const resources = {
    en: { translations: dotify(en) },
    fr: { translations: dotify(fr) },
    de: { translations: dotify(de) },
    it: { translations: dotify(it) }
};

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        // we init with resources
        resources: resources,
        fallbackLng: 'fr',
        debug: false,

        supportedLngs: SUPPORTED_LANGS,
        // Map regional tags (fr-CH, en-GB, …) to our bare supported codes so
        // navigator.languages like ['fr-CH','en-US','en'] does not skip fr-CH
        // and fall through to English.
        nonExplicitSupportedLngs: true,

        // have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ','
        },

        react: {
            useSuspense: false
        }
    });

const initialLng = i18n.resolvedLanguage || i18n.language || 'fr';
const normalizedInitialLng = normalizeSupportedLang(initialLng);

if (initialLng !== normalizedInitialLng) {
    i18n.changeLanguage(normalizedInitialLng);
} else {
    applyMomentLocale(normalizedInitialLng);
}
persistNormalizedLanguage(normalizedInitialLng);

i18n.on('languageChanged', (lng) => {
    const normalizedLng = normalizeSupportedLang(lng);
    persistNormalizedLanguage(normalizedLng);
    if (lng !== normalizedLng) {
        i18n.changeLanguage(normalizedLng);
        return;
    }

    applyMomentLocale(normalizedLng);
});

export default i18n;
